<template>
  <main class="main">
    <transition name="chartAccount-view">
      <v-container id="chartAccount-view" fluid tag="section">
        <div class="search mt-n3 pb-3">
          <v-btn color="primary" @click="openDialog(0, '')">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn class="mx-2" @click="getAllChartAccount()" fab small color="secondary">
            <v-icon> mdi-autorenew </v-icon>
          </v-btn>
          <v-text-field
            v-model="table.search"
            prepend-icon="mdi-magnify"
            class="input"
            label="Cari Akun Pembantu..."
            single-line
            hide-details
          ></v-text-field>
        </div>
        <div class="datatable">
          <v-data-table
            :headers="table.headers"
            :items="chartAccounts"
            hide-default-footer
            :loading="isLoading"
            :search="table.search"
            disable-pagination
            item-key="name"
            class="elevation-1"
            dense
          >
            <template v-slot:[`item.actions`]="{ item }">
              <v-menu bottom origin="center center" transition="scale-transition">
                <template v-slot:activator="{ on: menu, attrs }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn icon color="primary" dark v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                        <v-icon dark> mdi-menu </v-icon>
                      </v-btn>
                    </template>
                    <span>Menu</span>
                  </v-tooltip>
                </template>
                <v-list dense>
                  <v-list-item @click="deleteAccountHelper(item._id)">
                    <v-list-item-icon>
                      <v-icon>mdi-delete</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Hapus Akun Pembantu</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </div>
        <!-- <div class="datatable-action">
          <v-pagination
            v-model="pagination.page"
            :length="journalsPage"
            :total-visible="5"
            @input="getAllJournal()"
          ></v-pagination>
        </div> -->
      </v-container>
    </transition>
    <v-dialog v-model="isDialog" :max-width="700">
      <chart-account-helper-input
        v-if="selectedForm == 0"
        :account="selectedItem"
        @change-form="changeForm"
        @close-form="closeForm"
      />
    </v-dialog>
  </main>
</template>

<script>
import Swal from 'sweetalert2'
import Constant from '@/const'

import ConstantMixin from '@/constantMixin'
import ChartAccountHelperInput from '../components/accounting/ChartAccountHelperInput.vue'

const _ = require('lodash')
const moment = require('moment')
const axios = require('axios')
export default {
  mixins: [ConstantMixin],
  components: { ChartAccountHelperInput },
  name: 'ChartAccountViews',

  data() {
    return {
      menuCode: 'c-02',
      access: {
        write: false,
        update: false,
        delete: false
      },
      isLoading: false,
      isDialog: false,
      isAdmin: false,
      selectedForm: '',
      selectedItem: null,
      table: {
        search: '',
        headers: [
          {
            text: 'Akun Induk',
            value: 'accountParent',
            width: '150px',
            sortable: false,
            class: 'text-subtitle-1 font-weight-black'
          },
          {
            text: 'Nama',
            value: 'name',
            width: '150px',
            sortable: false,
            class: 'text-subtitle-1 font-weight-black'
          },
          {
            text: 'Saldo',
            value: 'nominal',
            width: '90px',
            sortable: false,
            class: 'text-subtitle-1 font-weight-black'
          },
          {
            text: '',
            align: 'center',
            value: 'actions',
            width: '50px',
            sortable: false,
            class: 'text-subtitle-1 font-weight-black'
          }
        ]
      },
      chartAccounts: [],
      chartAccountsPage: 0
    }
  },
  watch: {
    isDialog(newValue) {
      if (!newValue) {
        this.selectedForm = null
      }
    },
    'table.search'(val) {
      this.pagination.page = 1
      setTimeout(() => this.getAllChartAccount(), 300)
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.getAllChartAccount()
    })
  },
  methods: {
    getAllChartAccount(option) {
      try {
        this.isLoading = true
        this.runApiCalls(() => {
          axios
            .get(Constant.apiUrl.concat('/accounting/chartaccounthelper?search=', this.table.search))
            .then(response => {
              if (response.status == 200) {
                const { data, length } = response.data

                this.chartAccountsPage = Math.ceil(length / this.pagination.rowsPerPage)

                this.chartAccounts = data.map(c => {
                  return {
                    ...c,
                    accountParent: `${c.id_account.code} - ${c.id_account.name}`,
                    id_parent: c.id_account._id,
                    nominal: this.getCurrency(c.nominal)
                  }
                })
              }
              this.isLoading = false
            })
            .catch(error => {
              this.isLoading = false
              // console.log(error)
            })
        })
      } catch {
        this.isLoading = false
      }
    },
    deleteAccountHelper(id_accountHelper) {
      try {
        Swal.fire({
          title: 'Anda yakin akan menghapus Akun Pembantu ?',
          text: `Data tidak bisa dikembalikan, Akun Pembantu harus tidak memiliki saldo`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        })
          .then(result => {
            if (result.value) {
              this.runApiCalls(() => {
                axios
                  .delete(Constant.apiUrl.concat('/accounting/chartaccounthelper/', id_accountHelper))
                  .then(() => {
                    Constant.swalToast('success', 'Akun Pembantu berhasil dihapus')
                    this.getAllChartAccount()
                  })
                  .catch(error => {
                    if (error.response) {
                      const message = error.response.data.pesan
                      Swal.fire({
                        icon: 'error',
                        title: 'Terjadi Kesalahan',
                        text: message
                      })
                    } else if (error.request) {
                      Swal.fire({
                        icon: 'error',
                        title: 'Terjadi Kesalahan',
                        text: 'Tidak dapat menyambung ke server'
                      })
                    } else {
                      // eslint-disable-next-line
                      console.log('Something happened in the middle of request')
                    }
                  })
              })
            }
          })
          .catch(error => {
            if (error.response) {
              const message = error.response.data.pesan
              Swal.fire({
                icon: 'error',
                title: 'Terjadi Kesalahan',
                text: message
              })
            } else if (error.request) {
              Swal.fire({
                icon: 'error',
                title: 'Terjadi Kesalahan',
                text: 'Tidak dapat menyambung ke server'
              })
            } else {
              // eslint-disable-next-line
              console.log('Something happened in the middle of request')
            }
          })
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Terjadi Kesalahan',
          text: 'Tidak dapat menyambung ke server'
        })
      }
    },
    openDialog(index, item) {
      this.selectedItem = item
      switch (index) {
        default:
          this.changeForm(index)
          break
      }
      this.isDialog = true
    },
    changeForm(item) {
      this.selectedForm = item
    },
    closeForm() {
      this.isDialog = false
      this.getAllChartAccount()
    }
  }
}
</script>

<style lang="scss" scoped>
.search {
  display: flex;
  position: relative;
  align-items: center;
  justify-content: flex-end;
  right: 0;
}
.input {
  max-width: 30%;
}
.datatable {
  display: inline-block;
  width: 100%;
  height: 500px;
}
.main {
  width: 100%;
  flex-direction: column;
  position: relative;
  height: 95%;
  overflow-y: off;
}
.datatable-action {
  position: absolute;
  left: 10px;
  bottom: -8vh;
}
.btn-new {
  right: 50px;
  bottom: 1vh;
}
</style>
